export interface OemConfig {
  manufacturer: string
  label: string
  intentAction?: string
  intentPackage?: string
  instructions: string
}

export const PROBLEMATIC_OEMS: OemConfig[] = [
  {
    manufacturer: 'xiaomi',
    label: 'Xiaomi / Redmi / POCO',
    intentAction: 'miui.intent.action.OP_AUTO_START',
    intentPackage: 'com.miui.securitycenter',
    instructions: 'Ajustes → Apps → Tworks → Ahorro de batería → Sin restricciones + Autoarranque activado',
  },
  {
    manufacturer: 'huawei',
    label: 'Huawei / Honor',
    intentAction: 'huawei.intent.action.HSM_BOOTAPP_MANAGER',
    intentPackage: 'com.huawei.systemmanager',
    instructions: 'Ajustes → Apps → Tworks → Batería → Iniciar manualmente + Permitir actividad en segundo plano',
  },
  {
    manufacturer: 'oneplus',
    label: 'OnePlus',
    instructions: 'Ajustes → Batería → Optimización de batería → Tworks → No optimizar',
  },
  {
    manufacturer: 'oppo',
    label: 'Oppo',
    intentPackage: 'com.coloros.safecenter',
    instructions: 'Ajustes → Batería → Gestión de batería de apps → Tworks → Permitir actividad en segundo plano',
  },
  {
    manufacturer: 'vivo',
    label: 'Vivo / iQOO',
    intentPackage: 'com.vivo.permissionmanager',
    instructions: 'Ajustes → Batería → Consumo en segundo plano → Tworks → Permitir',
  },
  {
    manufacturer: 'realme',
    label: 'Realme',
    instructions: 'Ajustes → Batería → Tworks → Permitir actividad en segundo plano',
  },
]

export function detectOem(manufacturer: string | undefined | null): OemConfig | null {
  if (!manufacturer) return null
  const m = manufacturer.toLowerCase()
  return PROBLEMATIC_OEMS.find(o => m.includes(o.manufacturer)) ?? null
}
